var React = require('react');

class Header extends React.Component {
  render () {
    return (
      <div className="walkthrough-header">
        <a className="logo" href="/">
          <img src={this.props.logoUrl} alt="Statuspage Logo" />
          <span className="bep">Better Error Pages</span>
        </a>
        <span className="powered-by">Powered by <a href="http://statuspage.io" target="_blank">Statuspage</a></span>
      </div>
    );
  }
}

module.exports = Header;



// WEBPACK FOOTER //
// ./app/assets/javascripts/components/better_error_pages/walk_through/header.jsx